import { FETCH_GROUPS, ADD_GROUP, RESET_GROUPS } from '../actionTypes';

const initialState = {
  data: {},
  isLoadMore: false,
  info: {}
};

export default function(state = initialState, action=null){
  switch (action.type) {
    case ADD_GROUP:
      return {
        ...state,
        [action.payload._id]: {...action.payload}
      }
    case FETCH_GROUPS:
      let isLoadMore = true;
      console.log(action.payload);
      if (Object.keys(action.payload).length < 10) {
        isLoadMore = false;
      }
      return {
        ...state,
        data: {...state.data, ...action.payload},
        isLoadMore: isLoadMore
      }
    case RESET_GROUPS:
      return initialState
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/groups.js